import { useTheme } from "styled-components";
import { useGetCountriesAssets } from "contexts/AssetsContext";
import {ICountryAsset, ICountryAssetLite} from "models/Assets/ICountryAsset";
import {filterCountryByCountryCode} from "dataLayer/filters/filterCountryByCountryCode";
import {useRouter} from "next/router";

export default function useGetCountry(): ICountryAssetLite {
  const { country: countryAbbr , isChangeCountryPage} = useTheme();
  const countries = useGetCountriesAssets<ICountryAsset>();
  if (!countries?.length) {
    console.error(
      "Did you forget to fetch Countries in Component.getServerSideProps()?"
    );
    return null;
  }
  if(isChangeCountryPage){
    const router = useRouter();
    const ref = router.query["ref"] as string
    const country =  ref?.split("_")?.[2]
    if(country){
      return filterCountryByCountryCode(countries, country);
    }else{
      return filterCountryByCountryCode(countries, countryAbbr);
    }
  }

  return filterCountryByCountryCode(countries, countryAbbr);
}
